interface Config {
  API_BASE_URL: string;
  CMS_BASE_URL: string;
  GA_ID: string;
  AHREFS_KEY: string;
  CLARITY_ID: string;
  CHAT_WIDGET_URL: string;
}

const config: Config = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || 'https://api.akygacomponents.com:8443',
  CMS_BASE_URL:
    process.env.REACT_APP_CMS_BASE_URL || 'https://cms.akygacomponents.com',

  // Third-party tracking/chat. These fall back to the IDs already live on
  // the site today (all already public in the shipped build), so this
  // migration to consent-gated loading is behavior-preserving without
  // requiring new CI secrets - override via the REACT_APP_* env vars if a
  // deploy target should point elsewhere.
  GA_ID: process.env.REACT_APP_GA_ID || 'G-ZQ6LM29RTB',
  AHREFS_KEY: process.env.REACT_APP_AHREFS_KEY || '2pkCo9TCxOUUaKgKazdRKw',
  CLARITY_ID: process.env.REACT_APP_CLARITY_ID || 'okjt81zbsg',
  CHAT_WIDGET_URL:
    process.env.REACT_APP_CHAT_WIDGET_URL ||
    'https://ropla.e.gdms.cloud/liveChat?liveChatAccess=MF8yYmRlNjBiZjdmM2Q0MjYyODFhM2U3ODg3ZDBlNTZmZl9lYzc0ZDc0N2U4NDAmZWYzMjFiNTE3Yjk5NDEyZmZlMDEwYzljNmRkNDZkZWM=',
};

export default config;
